// -*-mode: rjsx -*-
// REACT
// eslint-disable-next-line
import React, { Component, useState, useEffect } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Paper from "@material-ui/core/Paper"

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"
import FlashExpand from "../Flash/FlashExpand.js"
import FlashCard from "../Flash/FlashCard.js"
//import FlashRankCard from "../Flash/FlashRankCard.js"
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
import FlashSwipeItem from "../Flash/FlashSwipeItem.js"
import FlashBasicComponent from "../Flash/FlashBasicComponent.js"
import FlashIssueChart from "../Flash/FlashIssueChart.js"
import FlashReasonsChart from "../Flash/FlashReasonsChart.js"
import HelpIcon from "@material-ui/icons/HelpOutline"

import * as _ from "lodash"

// throws the error that it can onlyl be overriden
const localStyles = theme => createStyles({

    testDiv: {
        // mobile
        padding: 0,
        paddingTop: 90,
        marginTop: 0,
        marginBottom: 120,
        marginLeft: "auto",
        marginRight: "auto",

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    rootOverride: {
        margin: 5,
        width: 360,
        maxHeight: 72,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        background: theme.palette.test.bg2,
    },

    rootExpandedOverride: {
        maxHeight: "none !important", // this will expand just to the height that's needed
        overflow: "hidden !important",
        background: theme.palette.test.fg3,
    },


    headerDiv: {
        marginLeft: 20,
        marginTop: 15,
        marginBottom: 20,
    },

    headerText: {
        fontSize: 30,
        fontWeight: 700,
        color: grey[800],
    },

    subheaderDiv: {
        marginLeft: 15,
        marginTop: 10,
        marginBottom: 0,
    },

    subheaderText: {
        fontSize: 22,
        fontWeight: 300,
        color: grey[800],
        marginBottom: 5,
    },


    bnavbarRoot: {
        ...theme.css.bnavbarRoot,
        height: 72,
        borderTop: "1px solid",
        borderTopColor: grey[300],
	borderRadius: 0,
    },


    bnavbarButtonsDiv: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        height: 72,
//        paddingTop: 20,
//        paddingBottom: 20,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
	    maxWidth: 600,
        },

//        backgroundColor: grey[800],        
    },

    nextButtonDiv: {
        width: "30%",
        height: "55%",
//        backgroundColor: grey[100],
    },

    backButtonDiv: {
        width: "30%",
        height: "55%",
    },


    nextButton: {
//        margin: 20,
//        padding: 8,
        width: "100%",
        height: "100%",
        
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.custom.nextButton,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.custom.nextButtonLight,
        },
        
    },

    backButton: {
//        margin: 20,
//        padding: 8,
        width: "100%",
        height: "100%",
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    betweenSpace: {

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            width: 0,
        },
        
//        width: 100,
    },
    
    separatorDiv: {
        ...theme.css.separatorDiv,

        margin: 0 ,
        marginBottom: 0,
        // test only for now
        borderRadius: 0,

        
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            // next to just to make them protrude
            // a bit more - better than sunken in
            // on a big screen
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
//            marginBottom: theme.css.separatorDiv.desktop.marginBottom,
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
//            borderRadius: theme.css.separatorDiv.desktop.borderRadius,
//            boxShadow: theme.css.separatorDiv.desktop.boxShadow,
        },
        
    },


    //
    // APPBAR
    //
    appbarRoot: {
        ...theme.css.appbarRoot,
        // desktop - if more than 600
        [theme.breakpoints.up("md")]: {
            // backgroundColor: theme.palette.primary.dark,
        },
    },

    appbarPlus: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },

    appbarMessage: {
        ...theme.css.appbarMessage,
        color: "#FFFFFF",
    },
    
    menuButton: {
        marginRight: theme.spacing(2),
        color: "#FFFFFF",
    },

    fakeContent: {
        height: "64px",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        padding: "11px 16px 11px 16px",
        flex: 1,
        width: "100%",
    },

    paperRoot_old: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        // maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
    },

    paperRoot: {
        height: 100,
        width: "100%",
        padding: 20,
        display: "flex",
        alignItems: "center",
        backgroundColor: grey[300],
        borderRadius: 20,
    },


    //
    // <FlashExpand>
    //

    helpText: {
        margin: 0,
        padding: 0,
        fontSize: "1.25rem", // default for h6
        fontWeight: 300, // default for h6
        lineHeight: 1.6, // default for h6
        color: grey[800],
        // backgroundColor: grey[200],
    },
    
    helpIcon: {
        margin: 0,
        marginLeft: "0.10rem",
        padding: 0,
        fontSize: "1.45rem", // increase of 20
        color: grey[500],
        marginBottom: "-0.4rem", // aligns perfectly with 1.25rem fontSize
        "&:hover": {
            fontSize: "1.65rem",
            marginLeft: "0rem", // font increase 20, maring change .20/2 = .10
            marginBottom: "-0.5rem", // font increase 20, maring change .20/2 = .10
        },
        // backgroundColor: grey[400],
    },
    
})

// eslint-disable-next-line
const useLocalStyles = makeStyles(localStyles, {name: "localStyles"})

/*
const fakeContent = (
    
    <div className={classes.fakeContent}>
    <Paper>BLAH</Paper>
  </div>
);
*/


class Tests extends Component {

    constructor(props){
        super(props)
        this.state = {
            variation: {
                current: "A",
                A: "/tests/a",
                B: "/tests/b",
            },
            reasonsData: this.makeReasonsData(),
        }
        // this.handleClick = this.handleClick.bind(this);

        
    }

    makeReasonsData = () => {
        let data = [
            {
                "category": "Offers better education in disadvantaged areas",
                "value": 45,
                "target": 80
            }, {
                "category": "They drain money from public schools",
                "value": 60,
                "target": 30
            }, {
                "category": "Avoids problems of unions; better teachers want to be there",
                "value": 92,
                "target": 100
            }, {
                "category": "They \"cherry pick\" better students from public schools",
                "value": 20,
                "target": 2
            }, {
                "category": "They \"cherry pick\" better students from public schools other",
                "value": 15,
                "target": 2
            }
        ]

        data = _.sortBy(data, ["value"])
        
        return data
    }

    

    render() {
        
        const { classes }  = this.props
        
	return(
            <React.Fragment>
	      <CssBaseline/>
              <div className={clsx(classes.testDiv)}>

              <FlashTopBar text="Testing Swipes" variation={this.state.variation}/>

                <FlashHeader text={"Census questions about immigration status"}/>

                <Typography className={classes.helpText}
                            variant="h6"
                            display="inline">
                  Rank your reasons by their importance to you. Click to generate ranking number. [...Swipe to delete reason. You can change order at any time]
                </Typography><HelpIcon className={classes.helpIcon}/>
                <FlashExpand isVisible={true} expanded={true}>
            <Typography className={classes.helpText}
            variant="h6"
            display="inline">
            Rank your reasons by their importance to you. Click to generate ranking number. [...Swipe to delete reason. You can change order at any time]
            </Typography>
            </FlashExpand>

                <div/>
                <div/>
                <div/>
                <div/>
                <div/>
                
                <FlashSwipeItem>
                  <div style={{
                      display:"flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: 100,
                      borderRadius: 20,
                      cursor: "pointer",
                      userSelect: "none",
                      backgroundColor: grey[300],
                  }}>display item</div>
                </FlashSwipeItem>

                {/*
                  <SwipeableListItem>
                    <Paper className={classes.paperRoot}>Illegals won't want to answer anyway</Paper>
                  </SwipeableListItem>
                 */}


                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    Reasons
                  </Typography>
                </div>

                <FlashBasicComponent/>

            <div style={{
                marginLeft: 20,
                marginRight: 20,
//                borderStyle: "solid",
                borderColor: grey[400],
                borderWidth: 1,
            }}>
              <FlashIssueChart title="Census questions about immigration status"/>
            </div>
sdf

                <div style={{
                    marginLeft: 20,
                    marginRight: 20,
                    //                borderStyle: "solid",
                    borderColor: grey[400],
                    borderWidth: 1,
                    height: this.state.reasonsData.length * 100 * 0.9 // make them a bit tighter
                }}>
                  <FlashReasonsChart
                    title="Census questions about immigration status"
                    data={this.state.reasonsData}/>
                </div>
                
                <FlashSwipeItem>
                  <FlashCard text="Census helps define congressional districts - need to be based on citizens. More text going into another couple of lines. This is first extra sentence. This is second extra sentence."/>
                </FlashSwipeItem>
                <FlashCard text="Illegals have been paying taxes & helping economy - need to be included"/>
                <FlashCard text="Illegals won't want to answer anyway"/>
                <FlashCard text="Citizenship question was used in past - just removed in 2010"/>
                <FlashCard text="Census needs to know head count for safety, education, healthcare"/>
                <FlashCard text="Constitution says 'persons' not citizens; try to count legals and illegals"/>
              </div>

              
            </React.Fragment>
	)
    }
}

Tests.propTypes = {
    classes: PropTypes.object.isRequired,
}

// this is the cleanest
// we have to put commonStyles ahead
// of styles for styles to override it
export default withStyles(
    theme => ({
            ...globalStyles(theme),
            ...localStyles(theme),
        }),
    { name: "Tests" }
)(Tests)
